module.exports = __webpack_public_path__ + "img/wallpaper_contact.1a481742.jpg";